import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Storage} from "../../../model/storage";
import {Testbed} from "../../../model/testbed";

class DataForStorageCreation {
  testbed: Testbed = new Testbed();
  storage: Storage = new Storage();
}

@Component({
  selector: 'aw-create-storage',
  templateUrl: './create-storage-dialog.component.html',
  styleUrls: ['./create-storage-dialog.component.scss']
})
export class CreateStorageDialogComponent implements OnInit {


  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DataForStorageCreation,
    public dialogRef: MatDialogRef<CreateStorageDialogComponent>,
  ) {


  }

  ngOnInit(): void {
  }


}


